import React, { useState } from 'react';
import { router } from '@inertiajs/react';

type Props = {
  q?: string;
  placeholder?: string;
  /** 右侧的计数文字之类 */
  right?: React.ReactNode;
  /** 额外的下拉、chip */
  children?: React.ReactNode;
};

// 搜索用回车提交，不做防抖自动搜。
//
// 防抖要引一个定时器、要处理组件卸载时的清理、还要决定「多久算停下来」——
// 而后台搜索是「我知道要找什么，敲完回车」的动作，不是边打边看的动作。
export function submitFilter(patch: Record<string, string | null>) {
  const url = new URL(window.location.href);
  Object.entries(patch).forEach(([k, v]) => {
    if (v === null || v === '') url.searchParams.delete(k);
    else url.searchParams.set(k, v);
  });
  // 换了筛选条件就回第一页 —— 留在第 7 页多半是空的。
  url.searchParams.delete('page');
  router.get(url.pathname + url.search, {}, { preserveState: false });
}

export default function FilterBar({ q, placeholder = '搜索…', right, children }: Props) {
  const [text, setText] = useState(q ?? '');

  return (
    <div className="mb-3 flex flex-wrap items-center gap-2">
      <div className="relative">
        <svg
          className="pointer-events-none absolute left-2.5 top-2 opacity-45"
          width="13"
          height="13"
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
        >
          <circle cx="7" cy="7" r="4.5" />
          <path d="M10.5 10.5L14 14" />
        </svg>
        <input
          value={text}
          placeholder={placeholder}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') submitFilter({ q: text });
          }}
          className="h-[30px] w-[260px] rounded-md border border-admin-line2 bg-admin-surface pl-7 pr-2.5 text-[12.5px]"
        />
      </div>
      {children}
      <span className="flex-1" />
      {right && <span className="text-[12px] tabular-nums text-admin-muted">{right}</span>}
    </div>
  );
}
